<div class="sidenav-container" [class.mobile]="isMobile">
    <div class="sidenav-header">
        <!--  <button mat-icon-button (click)="toggleCollapsed()">
            <mat-icon *ngIf="!collapsed">menu_open</mat-icon>
            <mat-icon *ngIf="collapsed">arrow_forward_ios</mat-icon>
        </button> -->
        <div class="logo-container">
            <img *ngIf="!collapsed" src="assets/ai-logo.png" alt="MedicAI Logo" class="logo">
        </div>
    </div>
    <mat-nav-list class="main-nav">
        <mat-divider></mat-divider>
        <div class="m-t-8"></div>
        <span [hidden]="!selectedGroup">
            <a mat-list-item routerLink="patients/schedule" matTooltip="Schedule" routerLinkActive="active"
                (click)="closeOnMobile()">
                <mat-icon>calendar_month</mat-icon>
                <span *ngIf="!collapsed">Schedule</span>
            </a>
            <a mat-list-item routerLink="patients/list" matTooltip="Patient List" routerLinkActive="active"
                (click)="closeOnMobile()">
                <mat-icon>medical_information</mat-icon>
                <span *ngIf="!collapsed">Patients</span>
            </a>
            <a mat-list-item routerLink="patients/results" matTooltip="Results" routerLinkActive="active"
                (click)="closeOnMobile()" class="results-nav-item">
                <div class="icon-with-badges">
                    <mat-icon>science</mat-icon>
                    <span class="badge-container">
                        <span class="badge badge-new" *ngIf="newResultsCount > 0">{{newResultsCount}}</span>
                        <span class="badge badge-failed" *ngIf="failedResultsCount > 0">{{failedResultsCount}}</span>
                        <span class="badge badge-unlinked" *ngIf="unlinkedResultsCount > 0">{{unlinkedResultsCount}}</span>
                    </span>
                </div>
                <span *ngIf="!collapsed">Results</span>
            </a>
            <!--
                The Inbox - tasks/inbox.md. Directly under Results, which is where the owner asked
                for it and where it reads correctly: both are worklists of things arriving from
                outside the practice, one from the labs and one from patients.

                TWO badges, from ONE /counts request. The Results item above derives its three by
                filtering every lab order in the practice in the browser; this one does not.
            -->
            <a mat-list-item routerLink="patients/inbox" matTooltip="Inbox" routerLinkActive="active"
                (click)="closeOnMobile()" class="inbox-nav-item">
                <div class="icon-with-badges">
                    <mat-icon>inbox</mat-icon>
                    <span class="badge-container">
                        <span class="badge badge-new" *ngIf="inboxNewCount > 0">{{inboxNewCount}}</span>
                        <span class="badge badge-review" *ngIf="inboxForReviewCount > 0">{{inboxForReviewCount}}</span>
                    </span>
                </div>
                <span *ngIf="!collapsed">Inbox</span>
            </a>
            <!-- Chat on the messaging hub (tasks/messaging-hub-architecture.md M1): toggles the floating window; hidden when chat is off. -->
            <a mat-list-item matTooltip="Chat" [class.active]="(chatUi.state$ | async)?.open" (click)="chatUi.toggle(); closeOnMobile()"
                class="inbox-nav-item" *ngIf="(chatService.enabled$ | async) !== false">
                <div class="icon-with-badges">
                    <mat-icon>forum</mat-icon>
                    <span class="badge-container" *ngIf="(chatService.unread$ | async) as chatUnread">
                        <span class="badge badge-new" *ngIf="chatUnread > 0">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
                    </span>
                </div>
                <span *ngIf="!collapsed">Chat</span>
            </a>
            <a mat-list-item routerLink="patients/filters" matTooltip="Patient Filters" routerLinkActive="active"
                (click)="closeOnMobile()">
                <mat-icon>filter_list</mat-icon>
                <span *ngIf="!collapsed">Filters</span>
            </a>

            <a mat-list-item routerLink="patients/coding" matTooltip="Coding" routerLinkActive="active"
                (click)="closeOnMobile()" *ngIf="showCoding">
                <mat-icon>payments</mat-icon>
                <span *ngIf="!collapsed">Coding</span>
            </a>
            <!-- The practice's MedicAI Connect dashboard, only for groups on Connect. -->
            <a mat-list-item routerLink="patients/connect" matTooltip="Connect" routerLinkActive="active"
                (click)="closeOnMobile()" *ngIf="isConnectGroup">
                <mat-icon>account_balance_wallet</mat-icon>
                <span *ngIf="!collapsed">Connect</span>
            </a>
            <!-- The "Theatre" item was removed by §3b: there is no theatre-list builder page.
                 The theatre list is exported from the expanded day on the schedule calendar. -->
            <a mat-list-item routerLink="patients/statistics" matTooltip="Statistics" routerLinkActive="active"
                (click)="closeOnMobile()" *ngIf="canViewStatistics">
                <mat-icon>analytics</mat-icon>
                <span *ngIf="!collapsed">Stats</span>
            </a>
            <a mat-list-item matTooltip="Help" routerLinkActive="active" (click)="openHelpDialog()">
                <!-- Unread messages from MedicAI Support live behind Help (the in-app support chat, M7). -->
                <mat-icon [matBadge]="(supportUnread$ | async) || null" matBadgeColor="warn" matBadgeSize="small"
                    [matBadgeHidden]="!(supportUnread$ | async)">help</mat-icon>
                <span *ngIf="!collapsed">Help</span>
            </a>
            <!--  <a mat-list-item routerLink="patients/dashboard" routerLinkActive="active">
            <mat-icon matTooltip="Dashboard">stacked_bar_chart</mat-icon>
            <span *ngIf="!collapsed">Dashboard</span>
        </a> -->
            <div class="m-t-8"></div>
            <mat-divider></mat-divider>

            <!-- <div class="m-t-20"></div>
            <ng-container *ngIf="isRecognitionSupported">
                <a mat-list-item matTooltip="Start Voice Command Recognition" (click)="startSpeechRecognition()"
                    *ngIf="!isRecognitionActive">
                    <mat-icon>record_voice_over</mat-icon>
                    <span *ngIf="!collapsed">Start</span>
                </a>
                <a mat-list-item matTooltip="Stop Voice Command Recognition" (click)="stopSpeechRecognition()"
                    *ngIf="isRecognitionActive">
                    <mat-icon>voice_over_off</mat-icon>
                    <span *ngIf="!collapsed">Stop</span>
                </a>
                <p *ngIf="detectedText" class="hint detectedText">{{detectedText}}</p>
            </ng-container> -->

            <!--    <div class="m-t-20"></div>
            <a mat-list-item routerLink="patients/beta" matTooltip="Beta Features" routerLinkActive="active"
                (click)="closeOnMobile()">
                <mat-icon svgIcon="beta" class="large-icon"></mat-icon>
                <span *ngIf="!collapsed">Beta</span>
            </a>
            <div class="m-t-20"></div>
            <mat-divider></mat-divider>
            <div class="m-t-20"></div>
            <a mat-list-item routerLink="patients/medprax" matTooltip="Medprax Features" routerLinkActive="active"
                (click)="closeOnMobile()">
                <mat-icon svgIcon="beta" class="large-icon"></mat-icon>
                <span *ngIf="!collapsed">Medprax</span>
            </a> -->


            <!-- <div class="m-t-20"></div>
        <a mat-list-item routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <mat-icon matTooltip="Home">home</mat-icon>
            <span *ngIf="!collapsed">AI Home</span>
        </a>
        <a mat-list-item routerLink="/pending-audio" routerLinkActive="active" (click)="closeOnMobile()">
            <mat-icon matTooltip="Cached Recordings">cached</mat-icon>
            <span *ngIf="!collapsed">Cached Recordings</span>
        </a>
        <a mat-list-item routerLink="/history" routerLinkActive="active" (click)="closeOnMobile()">
            <mat-icon matTooltip="History">history</mat-icon>
            <span *ngIf="!collapsed">History</span>
        </a>
        <div class="m-t-20"></div>
        <mat-divider></mat-divider> -->
            <!-- <a mat-list-item routerLink="/settings" routerLinkActive="active">
            <mat-icon matTooltip="Settings">settings</mat-icon>
            <span *ngIf="!collapsed">Settings</span>
        </a> -->
            <!--  <a mat-list-item (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            <span *ngIf="!collapsed">Logout</span>
        </a> -->
        </span>

    </mat-nav-list>
    <div class="spacer"></div>
    <!-- <div class="sidenav-footer" *ngIf="!collapsed">
        <button mat-raised-button color="primary" (click)="generatedDemoData()"><mat-icon>rocket_launch</mat-icon> Seed
            Demo</button>
    </div> -->
</div>